import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../helpers/api_helper';
import { PackageRankHistory, PackageRankHistoryState } from './types';
import { handleValidDate, handleValidTime } from '../../../helpers/helpers';
import { toast } from 'react-toastify';

export const getPackageRankHistory = createAsyncThunk(
  'packageRankHistory/fetch',
  async (params: URLSearchParams) => {
    const response = await axiosInstance.get('/package/package-rank/history', {
      params
    });
    return response.data.data;
  }
);

export const exportRankHistory = createAsyncThunk(
  'packageRankHistory/exportRankHistory',
  async (params: URLSearchParams) => {
    const response = await axiosInstance.get(
      '/package/package-rank/history/export',
      {
        params
      }
    );

    try {
      if (response?.data?.data?.usersPackageRankHistory) {
        const dataForExport = response?.data?.data?.usersPackageRankHistory.map(
          (u: any) => {
            return {
              userId: u?.userId,
              qualifiedRank: u?.qualifiedRank?.name,
              lifetimeRank: u?.lifetimeRank?.name,
              package: u?.packageRank?.name,
              dateCreated: u?.dateCreated
                ? `${handleValidDate(u.dateCreated)}, ${handleValidTime(
                    u.dateCreated
                  )}`
                : ''
            };
          }
        );

        return dataForExport;
      }

      if (response.data.message) {
        toast.success(response.data.message);
      }
    } catch (error: any) {
      toast.error(error.response.data.error);
    }
  }
);

export const exportHeaders = [
  { label: 'User', key: 'userId' },
  { label: 'Package Rank', key: 'package' },
  { label: 'Lifetime Rank', key: 'lifetimeRank' },
  { label: 'Qualified Rank', key: 'qualifiedRank' },
  { label: 'Date Created', key: 'dateCreated' }
];

const initialState = {
  data: [],
  dataForExport: [],
  totalCount: 0,
  loading: false,
  loadingExport: false
} as PackageRankHistoryState;

const packageRankHistorySlice = createSlice({
  name: 'packageRankHistory',
  initialState,
  reducers: {
    removeRankHistoryForExport(state) {
      state.dataForExport = [];
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getPackageRankHistory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPackageRankHistory.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.data = payload.usersPackageRankHistory as PackageRankHistory[];
      state.totalCount = payload.count;
    });
    builder.addCase(getPackageRankHistory.rejected, (state) => {
      state.loading = false;
    });

    //loading export
    builder.addCase(exportRankHistory.pending, (state) => {
      state.loadingExport = true;
    });
    builder.addCase(exportRankHistory.fulfilled, (state, { payload }) => {
      state.loadingExport = false;
      state.dataForExport = payload;
    });
    builder.addCase(exportRankHistory.rejected, (state) => {
      state.loadingExport = false;
    });
  }
});

export const { removeRankHistoryForExport } = packageRankHistorySlice.actions;

export default packageRankHistorySlice.reducer;
